/**
 * HTTP status codes used across the app's error/response handling.
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  TEMPORARY_REDIRECT: 307,
  PERMANENT_REDIRECT: 308,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  IM_A_TEAPOT: 418,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505
}

/**
 * Supported TLS/SSL versions.
 */
export const TLS_VERSIONS = {
  TLS_V1: 'TLS_V1',
  TLS_V1_1: 'TLS_V1_1',
  TLS_V1_2: 'TLS_V1_2',
  TLS_V1_3: 'TLS_V1_3',
  SSL_V3: 'SSL_V3',
  MINIMUM_SUPPORTED: 'MINIMUM_SUPPORTED',
  MAXIMUM_SUPPORTED: 'MAXIMUM_SUPPORTED'
}

/**
 * HTTP URL schemes.
 */
export const HTTP_SCHEME = {
  HTTP: 'HTTP',
  HTTPS: 'HTTPS'
}
